import { PageHeader, StatCard } from '@redbax/ui-kit';
import { Building2, CheckCircle2, Clock, Bot } from 'lucide-react';
import { useAdminStats } from '../api/admin-hooks';

export function AdminDashboardPage() {
  const { data, isLoading } = useAdminStats();

  return (
    <div>
      <PageHeader title="Admin Dashboard" description="Platform-wide overview" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Organizations"
          value={data?.totalOrgs ?? 0}
          icon={<Building2 className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="Active Organizations"
          value={data?.activeOrgs ?? 0}
          icon={<CheckCircle2 className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="Pending Approvals"
          value={data?.pendingOrgs ?? 0}
          icon={<Clock className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="AI Services"
          value={data?.totalServices ?? 0}
          icon={<Bot className="h-4 w-4" />}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
